export type Environment = 'devbox' | 'isolated_qa' | 'qa' | 'preprod' | 'prod';

/**
 * Detects the current service environment based on the window location.
 *
 * @returns The service environment ('devbox', 'isolated_qa', 'qa', 'preprod', or 'prod')
 */
export const getServiceEnvironment = (): Environment => {
  const url = new URL(window.location.href);
  const origin = url.host.toLowerCase();

  if (
    origin.startsWith('localhost') ||
    origin.endsWith('-mydev.dev.stripe.me') ||
    origin.endsWith('-dev.dev.stripe.me')
  ) {
    return 'devbox';
  } else if (origin.endsWith('.dev.stripe.me')) {
    return 'isolated_qa';
  } else if (origin.startsWith('qa-')) {
    return 'qa';
  } else if (origin.startsWith('preprod-')) {
    return 'preprod';
  }

  return 'prod';
};
